import { useContext } from 'react';
import PrivateAppConfigContext from 'contexts/PrivateAppConfigContext';

const usePrivateAppConfig = () => useContext(PrivateAppConfigContext);

export default usePrivateAppConfig;
